import { Logo } from "./Header";

export default function Footer() {
    return (
        <footer className="bg-forest text-white" data-testid="site-footer">
            <div className="mx-auto grid max-w-7xl gap-10 px-6 py-16 md:grid-cols-4">
                <div className="md:col-span-2">
                    <Logo dark />
                    <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/70">
                        TechBloom is a research, education and career opportunity ecosystem connecting students with faculty, projects, internships and career pathways.
                    </p>
                    <p className="mt-6 font-display text-sm font-semibold tracking-[0.2em] text-sand">DISCOVER. CONNECT. EXPERIENCE. BLOOM.</p>
                </div>
                <div>
                    <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-white/50">Explore</h4>
                    <ul className="mt-4 space-y-2 text-sm text-white/80">
                        <li><a href="/internships" className="transition-colors duration-200 hover:text-sand">Internship Hub</a></li>
                        <li><a href="/projects" className="transition-colors duration-200 hover:text-sand">Research & Projects</a></li>
                        <li><a href="/faculty" className="transition-colors duration-200 hover:text-sand">Faculty Network</a></li>
                        <li><a href="/career-paths" className="transition-colors duration-200 hover:text-sand">Career Path Explorer</a></li>
                    </ul>
                </div>
                <div>
                    <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-white/50">Contact</h4>
                    <ul className="mt-4 space-y-2 text-sm text-white/80">
                        <li>Support: <a href="mailto:support@techbloom.com" className="text-sand">support@techbloom.com</a></li>
                        <li>General: <a href="mailto:hello@techbloom.com" className="text-sand">hello@techbloom.com</a></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/10 py-6 text-center text-xs text-white/50">
                © 2026 TechBloom. Where research meets real-world innovation.
            </div>
        </footer>
    );
}
